import { BlacklistNameEntry } from "../types/BlacklistNameEntry";
import { removeMiddleInitial } from "./helpers";

const blacklistSearchSuffixes = [
  ", Esq.",
  "CCIM, SIOR",
  "CFA",
  "CPA",
  "CPA MST",
  "CPA, MT",
  "CRPC",
  "DDS",
  "Esq",
  "Esq.",
  "Esq. MnCP",
  "Esq. P.A.",
  "Esq. PC",
  "Esq., CPA",
  "Esq.4",
  "Esquire",
  "hacohen",
  "II",
  "III",
  "IV",
  "J.D.",
  "Jr",
  "Jr.",
  "Jr., Esq",
  "lls",
  "M.D.",
  "MBA",
  "P.A Esq.",
  "P.A.",
  "P.A. Esq.",
  "P.E.",
  "P.L.S.",
  "PA",
  "PC",
  "PLLC",
  "PLS",
  "SIOR",
  "Sr.",
  "test"
];

const removeBlacklistSearchSuffixes = (name: string) => {
  let cleanedName = name.trim();
  const sortedSuffixes = [...blacklistSearchSuffixes].sort((a, b) => b.length - a.length);

  for (const suffix of sortedSuffixes) {
    if (cleanedName.toLowerCase().endsWith(suffix.toLowerCase())) {
      cleanedName = cleanedName.slice(0, -suffix.length).trim();
      cleanedName = cleanedName.replace(/,$/, "").trim();
      break;
    }
  }

  return cleanedName;
};

export const formatNamesForPatriotAndBlacklistSearch = (entries: BlacklistNameEntry[]) => {
  const processedNames = entries.reduce((acc: string[], entry) => {
    const { name, isCompany } = entry;
    const trimmedName = name?.trim() || "";

    if (!trimmedName) return acc;
    const nameWithoutSuffix = removeBlacklistSearchSuffixes(trimmedName);

    if (isCompany) {
      return [...acc, nameWithoutSuffix];
    }

    const nameInParts = nameWithoutSuffix.split(" ");
    if (nameInParts.length < 3) {
      return [...acc, nameWithoutSuffix];
    }

    const firstAndLastName = `${nameInParts[0]} ${nameInParts[nameInParts.length - 1]}`;
    const firstLastAndMiddleInitial = `${nameInParts[0]} ${nameInParts[1][0]} ${nameInParts[nameInParts.length - 1]}`;

    return [
      ...acc,
      nameWithoutSuffix,
      removeMiddleInitial(nameWithoutSuffix),
      firstAndLastName,
      firstLastAndMiddleInitial
    ];
  }, []);

  return [...new Set(processedNames)].filter(Boolean);
};
